import parse from 'html-react-parser'

import Link from 'next/link'
import { LinkList, LinkCard } from '@/components/nav/primary/NavPrimaryDropdownComponents'

import type { ApiGetMenu } from '@/components/nav/primary/types'

type NavPrimaryDropdownProps = {
  overviewLink: {
    type: string
    value: string
    url: string
    name: string
    title: string
    target: string
  }
  columns: ApiGetMenu['acf']['menu_columns']
  active?: boolean
  onClick?: any
}

const dropdownClass = `
  dropdown
  mt-2
  bg-white
  transition-all
  duration-300
  ease-in-out

  l:px-24

  l-up:rounded-tl-md
  l-up:rounded-tr-md
  l-up:rounded-bl-lg
  l-up:rounded-br-lg
  l-up:drop-shadow-[0px_4px_24px_rgba(0,0,0,0.08)]
`

export default function NavPrimaryDropdown({
  columns,
  overviewLink,
  active = false,
  onClick = null,
}: NavPrimaryDropdownProps) {
  const columnComponents = columns.map((column, index) => {
    const type = column.acf_fc_layout
    const key = `column-${type}-${index}`

    if (type === 'link_list') {
      const links = column.links || []

      return (
        <div key={key} className="border-grey-300 l-up:w-[322px] l-up:border-t l-up:pt-s">
          <LinkList key={key} links={links} onClick={onClick} />
        </div>
      )
    }

    if (type === 'link_card') {
      const image = column?.image
      const link = column?.link

      if (!image || !link) {
        return null
      }

      return (
        <div key={key} className="l:last-mt-0 w-[322px] l:mt-24">
          <LinkCard image={image} link={link} onClick={onClick} />
        </div>
      )
    }
  })

  // Apply active class
  const activeClass = active
    ? 'open l-up:opacity-100 l-up:pointer-events-auto'
    : 'closed l-up:opacity-0 l-up:pointer-events-none'

  return (
    <nav className={`${dropdownClass} ${activeClass}`}>
      {overviewLink?.title && overviewLink?.url ? (
        <Link
          href={overviewLink.url}
          className="inline-block w-full text-left font-bold hover:text-primary l:mb-8 l-up:mb-20"
          onClick={onClick}>
          <span data-title={parse(overviewLink.title)}>
            <span>{parse(overviewLink.title)} &gt;</span>
          </span>
        </Link>
      ) : null}

      <div className="l-up:flex l-up:gap-24">{columnComponents}</div>
    </nav>
  )
}
